import React from 'react'
import  mainbanner from "../images/main_banner photo.jpg";
import happycustomer from "../images/Happy_customer.jpg";
import koffeehouse_ambienace from "../images/koffewwhouse-ambience.jpg";

function Slider() {
  return (
    <div>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={mainbanner} className="d-block w-100" alt="Kofee House"/>
    </div>
    <div className="carousel-item">
      <img src={happycustomer} className="d-block w-100" alt="Koffee House Krishnagar"/>
    </div>
    <div className="carousel-item">
      <img src={koffeehouse_ambienace} className="d-block w-100" alt="Best Restaurant in Krishnagar"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider